// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.img-30[data-v-023eaee6] {\n    max-width: 30%;\n    min-height: 1px;\n    height: auto;\n}\n.img-45[data-v-023eaee6] {\n    max-width: 45%;\n    min-height: 1px;\n    height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
